import ExportPartnerAccountsPage from './ExportPartnerAccountsPage';

export default ExportPartnerAccountsPage;
